import { Component, Element, h, Prop, Watch } from '@stencil/core';

@Component({
  tag: 'patternlib-list',
  shadow: true,
  styleUrl: 'patternlib-list.scss',
})
export class PatternlibList {
  @Element() hostElement: HTMLPatternlibListElement;

  private itemHeightOldValue: string;
  private labelWidthOldValue: string;
  private noSeparatorOldValue: boolean;

  /**
   * Set the height for each list item in px.
   */
  @Prop() itemHeight = '48px';

  /**
   * Define the label width in percent.
   */
  @Prop() labelWidth = '50%';

  /**
   * Hide the separator lines between the items.
   */
  @Prop() noSeparator: boolean;

  /**
   * Set the width of the list.
   */
  @Prop() width = '100%';

  componentDidUpdate() {
    this.updateProps();
  }

  @Watch('itemHeight')
  itemHeightWatcher(newValue: string, oldValue: string) {
    if (typeof newValue === 'string') {
      this.itemHeightOldValue = oldValue;
    }
  }

  @Watch('labelWidth')
  labelWidthWatcher(newValue: string, oldValue: string) {
    if (typeof newValue === 'string') {
      this.labelWidthOldValue = oldValue;
    }
  }

  @Watch('noSeparator')
  noSeparatorWatcher(newValue: boolean, oldValue: boolean) {
    if (typeof newValue === 'boolean') {
      this.noSeparatorOldValue = oldValue;
    }
  }

  private queryListItems() {
    const slot = this.hostElement.shadowRoot.querySelector('slot') as HTMLSlotElement;
    const nodes = slot?.assignedNodes().filter(node => node.nodeName === 'PATTERNLIB-LIST-ITEM') ?? [];
    return nodes.map(node => node as unknown as HTMLPatternlibListItemElement);
  }

  private queryListHead() {
    const slot = this.hostElement.shadowRoot.querySelector('slot') as HTMLSlotElement;
    const node = slot?.assignedNodes().filter(node => node.nodeName === 'PATTERNLIB-LIST-HEAD') ?? null;
    return node as unknown as HTMLPatternlibListHeadElement;
  }

  private updateProps = (): void => {
    const listItems = this.queryListItems();
    if (listItems.length === 0) {
      throw new Error('[patternlib-list] Must have at least one item');
    }
    listItems.map(item => {
      if (item.itemHeight === '' || item.itemHeight === this.itemHeightOldValue) {
        item.itemHeight = this.itemHeight;
      }
      if (item.labelWidth === '' || item.labelWidth === this.labelWidthOldValue) {
        item.labelWidth = this.labelWidth;
      }
      if (item.noSeparator === undefined || item.noSeparator === this.noSeparatorOldValue) {
        item.noSeparator = this.noSeparator;
      }
    });

    const listHead = this.queryListHead();
    if (listHead[0]) listHead[0].labelWidth = this.labelWidth;
  };

  render() {
    return (
      <div style={{ width: this.width }}>
        <slot onSlotchange={this.updateProps} />
      </div>
    );
  }
}
